var _defs, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgAdmDashboard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.168,
    height: 15.168,
    viewBox: "0 0 15.168 15.168",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.843,11.427H8.9a.845.845,0,0,0,.843-.843V3.843A.845.845,0,0,0,8.9,3H3.843A.845.845,0,0,0,3,3.843v6.741A.845.845,0,0,0,3.843,11.427Zm0,6.741H8.9a.845.845,0,0,0,.843-.843V13.955a.845.845,0,0,0-.843-.843H3.843A.845.845,0,0,0,3,13.955v3.371A.845.845,0,0,0,3.843,18.168Zm8.427,0h5.056a.845.845,0,0,0,.843-.843V10.584a.845.845,0,0,0-.843-.843H12.269a.845.845,0,0,0-.843.843v6.741A.845.845,0,0,0,12.269,18.168ZM11.427,3.843V7.213a.845.845,0,0,0,.843.843h5.056a.845.845,0,0,0,.843-.843V3.843A.845.845,0,0,0,17.326,3H12.269A.845.845,0,0,0,11.427,3.843Z",
    transform: "translate(-3 -3)"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAdmDashboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/admDashboard.8682da29.svg";
export { ForwardRef as ReactComponent };